module.exports = __webpack_public_path__ + "mx.svg?ecb939bed95b9c932d0c1fa272eb5da6";